<template>
    <div>
        <mq-layout :mq="['mobile_sm', 'mobile_md']" class="carousel-courses">
            <div class="carousel-courses__item"
                 v-for="(course, index) in getLimitedCourses"
                 :key="index"
            >
                <TotemLearningPathItemMosaic v-if="course.percentageCompleted >= 0" :learningPath="course" />
                <TotemCourseItemMosaic v-else :course="course" />
            </div>
            <TotemButton
                icon="add"
                size="medium"
                color="primary"
                class="carousel-courses__load-more"
                @click="loadMore"
                v-if="limit < courses.length"
                :label="$t('General.load_more')"
            />
        </mq-layout>

        <mq-layout mq="desktop_l+">
            <Carousel class="carousel-courses" :items="courses" :theme="theme">
                <template v-slot:default="swiper">
                    <slot :course="swiper.item">
                        <TotemLearningPathItemMosaic v-if="swiper.item.percentageCompleted >= 0" :learningPath="swiper.item" />
                        <TotemCourseItemMosaic v-else :course="swiper.item" />
                    </slot>
                </template>
            </Carousel>
        </mq-layout>
    </div>
</template>

<script>
    import Carousel from 'components/user/summary/carousel/Carousel'

    export default {
        components: {
            Carousel
        },
        props: {
            courses: Array,
            theme: {
                required: true
            }
        },
        data () {
            return {
                limit: 6
            }
        },
        computed: {
            getLimitedCourses () {
                return this.courses.filter((el, index) => index < this.limit)
            }
        },
        methods: {
            loadMore () {
                this.limit += 6
            }
        }
    }
</script>

<style lang="scss" scoped>
    .carousel-courses {
        @include course_list;
        margin: 0;

        [class*="desktop"] & {
            padding: 0 0 60px;
            margin: 0;
        }

        &__item {
            @include course-list-item;
        }

        &__load-more {
            align-self: center;
            margin: 30px auto;
        }
    }
</style>

<style lang="scss">
    .carousel-courses {
        .swiper-slide {
            width: 342.6px !important;

            [class*="desktop_xxl"] &,
            [class*="desktop_xl"] & {
               width: calc(25% - 20px) !important;
            }

            [class*="desktop_l"] & {
                width: calc(33.3333% - 15px) !important;
            }
        }
    }
</style>
